// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select-bot-modal-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.select-bot-modal-title {
  margin: 0;
  font-size: 1.5rem;
  color: #333;
  font-weight: 600;
}

/* Top-right close button — mirrors \`.channel-modal-close\` (Channels page)
   so the nested Slack/Telegram connect modals close the same way and look
   identical to the channel modal they open from. */
.select-bot-modal-close {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #6b6b78;
  font-size: 16px;
  cursor: pointer;
  transition: background 0.15s ease;
}
.select-bot-modal-close:hover {
  background: #f2eefe;
  color: #5616ea;
}

.select-bot-info-box {
  display: flex;
  align-items: center;
  gap: 15px;
  background-color: #5616ea25;
  border-radius: 10px;
  padding: 14px;
  margin-bottom: 20px;
  line-height: 1.45;
  border-left: 5px solid #5616ea;
}

.select-bot-info-icon {
  font-size: 32px;
  color: #5616ea;
  flex-shrink: 0;
}

.select-bot-info-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.select-bot-info-content p {
  margin: 0;
}

.select-bot-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 0;
}

.select-bot-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 30px 0;
}

.select-bot-empty p {
  color: #666;
  font-size: 1.1rem;
  margin: 0;
  max-width: 300px;
}

.select-bot-form-control {
  margin-bottom: 0px;
}

.select-bot-form-control .MuiInputLabel-root {
  color: gray;
}

.select-bot-form-control .MuiInputLabel-root.Mui-focused {
  color: #5616ea;
}

.auto-response-mode-section {
  margin-top: 20px;
  padding: 4px 16px 8px 16px;
  background-color: #fafafa;
  border-radius: 10px;
  border: 1px solid #ececec;
}

.auto-response-mode-label {
  font-size: 0.78rem;
  font-weight: 600;
  color: #777;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  padding: 10px 0 4px 0;
}

.auto-response-mode-group {
  display: flex;
  flex-direction: column;
}

.auto-response-mode-option {
  margin: 0 !important;
  padding: 12px 0 !important;
  align-items: flex-start !important;
  width: 100%;
  border-radius: 6px;
  transition: background-color 0.15s ease;
}

.auto-response-mode-option .MuiRadio-root {
  padding: 2px 10px 0 0;
  /* The circle has a 2px inset inside the Material icon's viewBox. */
  margin-left: -2px;
}

.auto-response-mode-option + .auto-response-mode-option {
  border-top: 1px solid #e8e8e8;
}

.auto-response-mode-option .MuiFormControlLabel-label {
  flex: 1 1;
  line-height: 1.35;
}

.auto-response-mode-option-text {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.auto-response-mode-option-title {
  font-size: 1rem;
  font-weight: 600;
  color: #222;
  line-height: 1.3;
}

.auto-response-mode-option.is-selected .auto-response-mode-option-title {
  color: #5616ea;
}

.auto-response-mode-option-help {
  font-size: 0.85rem;
  color: #666;
  line-height: 1.4;
  font-weight: 400;
}

.select-bot-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
}

.select-bot-modal-actions button {
  text-transform: none;
  font-family: 'Poppins', sans-serif;
  font-size: 1rem;
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./src/components/SelectBotModal.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;;mDAEmD;AACnD;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,kCAAkC;EAClC,WAAW;EACX,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,qBAAqB;EACrB,mEAAmE;EACnE,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,SAAO;EACP,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".select-bot-modal-header {\r\n  display: flex;\r\n  align-items: center;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.select-bot-modal-title {\r\n  margin: 0;\r\n  font-size: 1.5rem;\r\n  color: #333;\r\n  font-weight: 600;\r\n}\r\n\r\n/* Top-right close button — mirrors `.channel-modal-close` (Channels page)\r\n   so the nested Slack/Telegram connect modals close the same way and look\r\n   identical to the channel modal they open from. */\r\n.select-bot-modal-close {\r\n  margin-left: auto;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 34px;\r\n  height: 34px;\r\n  border: none;\r\n  border-radius: 8px;\r\n  background: transparent;\r\n  color: #6b6b78;\r\n  font-size: 16px;\r\n  cursor: pointer;\r\n  transition: background 0.15s ease;\r\n}\r\n.select-bot-modal-close:hover {\r\n  background: #f2eefe;\r\n  color: #5616ea;\r\n}\r\n\r\n.select-bot-info-box {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 15px;\r\n  background-color: #5616ea25;\r\n  border-radius: 10px;\r\n  padding: 14px;\r\n  margin-bottom: 20px;\r\n  line-height: 1.45;\r\n  border-left: 5px solid #5616ea;\r\n}\r\n\r\n.select-bot-info-icon {\r\n  font-size: 32px;\r\n  color: #5616ea;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.select-bot-info-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n}\r\n\r\n.select-bot-info-content p {\r\n  margin: 0;\r\n}\r\n\r\n.select-bot-loading {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  padding: 40px 0;\r\n}\r\n\r\n.select-bot-empty {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  text-align: center;\r\n  padding: 30px 0;\r\n}\r\n\r\n.select-bot-empty p {\r\n  color: #666;\r\n  font-size: 1.1rem;\r\n  margin: 0;\r\n  max-width: 300px;\r\n}\r\n\r\n.select-bot-form-control {\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.select-bot-form-control .MuiInputLabel-root {\r\n  color: gray;\r\n}\r\n\r\n.select-bot-form-control .MuiInputLabel-root.Mui-focused {\r\n  color: #5616ea;\r\n}\r\n\r\n.auto-response-mode-section {\r\n  margin-top: 20px;\r\n  padding: 4px 16px 8px 16px;\r\n  background-color: #fafafa;\r\n  border-radius: 10px;\r\n  border: 1px solid #ececec;\r\n}\r\n\r\n.auto-response-mode-label {\r\n  font-size: 0.78rem;\r\n  font-weight: 600;\r\n  color: #777;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.05em;\r\n  padding: 10px 0 4px 0;\r\n}\r\n\r\n.auto-response-mode-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.auto-response-mode-option {\r\n  margin: 0 !important;\r\n  padding: 12px 0 !important;\r\n  align-items: flex-start !important;\r\n  width: 100%;\r\n  border-radius: 6px;\r\n  transition: background-color 0.15s ease;\r\n}\r\n\r\n.auto-response-mode-option .MuiRadio-root {\r\n  padding: 2px 10px 0 0;\r\n  /* The circle has a 2px inset inside the Material icon's viewBox. */\r\n  margin-left: -2px;\r\n}\r\n\r\n.auto-response-mode-option + .auto-response-mode-option {\r\n  border-top: 1px solid #e8e8e8;\r\n}\r\n\r\n.auto-response-mode-option .MuiFormControlLabel-label {\r\n  flex: 1;\r\n  line-height: 1.35;\r\n}\r\n\r\n.auto-response-mode-option-text {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 3px;\r\n}\r\n\r\n.auto-response-mode-option-title {\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  color: #222;\r\n  line-height: 1.3;\r\n}\r\n\r\n.auto-response-mode-option.is-selected .auto-response-mode-option-title {\r\n  color: #5616ea;\r\n}\r\n\r\n.auto-response-mode-option-help {\r\n  font-size: 0.85rem;\r\n  color: #666;\r\n  line-height: 1.4;\r\n  font-weight: 400;\r\n}\r\n\r\n.select-bot-modal-actions {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 12px;\r\n  margin-top: 24px;\r\n}\r\n\r\n.select-bot-modal-actions button {\r\n  text-transform: none;\r\n  font-family: 'Poppins', sans-serif;\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
